<template>
    <form id="onboarding-de" class="wrapper wrapper-tab wrapper-tab-1" role="form" method="post" @submit.prevent="" novalidate>
        <header>
            <span class="new-headline-xlg text-centered">Lebensqualität mit “Apps auf Rezept”</span>
        </header>

        <div class="text-wrapper">
            <p class="new-text-xl text-centered"><strong>Einwilligungserklärung</strong> in die Verarbeitung von personenbezogenen Daten durch <strong>Vitadio</strong> im Rahmen der wissenschaftlichen Evaluation von digitalen Gesundheitsanwendungen im Diabetes Sektor.</p>
            <p class="new-text-lg text-centered">Hiermit willige ich ein, an dem in der vorherigen Probandeninformation beschriebenen Evaluationsprojekt (Real World Evidence Studie) teilzunehmen und stelle meine Daten zur Verarbeitung für wissenschaftliche Zwecke zur Verfügung.<br>Ich stimme zu, dass das Team von Vitadio:</p>

            <ul>
                <div>
                    <figure>
                        <span class="material-symbols-rounded full-circle icon-check-list text-green"><span>check</span></span>
                    </figure>
                    <li class="new-text-xl">mich per Telefon und per E-Mail kontaktiert,</li>
                </div>

                <div>
                    <figure>
                        <span class="material-symbols-rounded full-circle icon-check-list text-green"><span>check</span></span>
                    </figure>
                    <li class="new-text-xl">personenbezogene Daten von mir, wie in der Probandeninformation sowie der <a href="https://vitadio.de/datenschutzerklarung" target="_blank">Datenschutzerklärung</a> beschrieben, erhebt,</li>
                </div>

                <div>
                    <figure>
                        <span class="material-symbols-rounded full-circle icon-check-list text-green"><span>check</span></span>
                    </figure>
                    <li class="new-text-xl">auf meine Nutzerdaten innerhalb der App zugreifen darf,</li>
                </div>

                <div>
                    <figure>
                        <span class="material-symbols-rounded full-circle icon-check-list text-green"><span>check</span></span>
                    </figure>
                    <li class="new-text-xl">diese Daten speichert, weiterverarbeitet und in anonymisierter Form veröffentlicht, sobald es der Forschungszweck erlaubt, d.h. sobald die Datenerfassung abgeschlossen ist.</li>
                </div>
            </ul>

            <p class="new-text-lg">Soweit sich aus meinen Daten Hinweise auf meine Gesundheit ergeben, bezieht sich meine Einwilligung auch auf diese Daten.</p>
        </div>

        <div v-if="type === 'first'" class="form-input-radio-button-wrapper-two-columns">
            <div
                class="form-input-radio-button-big"
                id="yes"
                @click="onClickButton()"
                >
                <div class="form-input-radio-button-inner">
                    <figure class="form-input-radio-button-icon">
                        <svg width="40" height="40" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.9912 31.3305C24.4562 31.3305 31.3184 24.4682 31.3184 16.0031C31.3184 7.53807 24.4562 0.675781 15.9912 0.675781C7.52627 0.675781 0.664062 7.53807 0.664062 16.0031C0.664062 24.4682 7.52627 31.3305 15.9912 31.3305Z" fill="#54DBA3"/>
                        <path d="M16 32.0003C7.17759 32.0003 0 24.8227 0 16.0002C0 7.17767 7.17759 0 16 0C24.8224 0 32 7.17767 32 16.0002C32 24.8227 24.8224 32.0003 16 32.0003ZM16 1.34565C7.91975 1.34565 1.34435 7.91983 1.34435 16.0015C1.34435 24.0831 7.91847 30.6573 16 30.6573C24.0815 30.6573 30.6556 24.0831 30.6556 16.0015C30.6556 7.91983 24.0815 1.34565 16 1.34565Z" fill="#54DBA3"/>
                        <path d="M14.0928 23.7985C13.6653 23.7985 13.2544 23.629 12.9514 23.326L5.69159 16.0662C5.06114 15.4357 5.06114 14.4149 5.69159 13.7845C6.32203 13.154 7.34282 13.154 7.97326 13.7845L14.0928 19.9041L23.9771 10.0197C24.6076 9.38926 25.6283 9.38926 26.2588 10.0197C26.8892 10.6502 26.8892 11.671 26.2588 12.3014L15.2343 23.326C14.9313 23.629 14.5217 23.7985 14.0928 23.7985Z" fill="white"/>
                        </svg>
                    </figure>
                    <span class="label-static">Ja</span>
                </div>
            </div>

            <div
                class="form-input-radio-button-big form-input-radio-button--danger"
                id="no"
                @click="openModal"
                >
                <div class="form-input-radio-button-inner">
                    <figure class="form-input-radio-button-icon">
                        <svg width="40" height="40" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.5 31C24.7843 31 31.5 24.2843 31.5 16C31.5 7.71573 24.7843 1 16.5 1C8.21573 1 1.5 7.71573 1.5 16C1.5 24.2843 8.21573 31 16.5 31Z" fill="#FF3E57"/>
                        <path d="M10.1199 25C9.70499 25 9.29141 24.8415 8.97446 24.5258C8.34185 23.8932 8.34185 22.8689 8.97446 22.2363L22.736 8.47447C23.3686 7.84184 24.3929 7.84184 25.0255 8.47447C25.6582 9.10709 25.6582 10.1314 25.0255 10.764L11.264 24.5258C10.9483 24.8415 10.5334 25 10.1186 25H10.1199Z" fill="white"/>
                        <path d="M16.5 32C7.67759 32 0.5 24.8224 0.5 16C0.5 7.17759 7.67759 0 16.5 0C25.3224 0 32.5 7.17759 32.5 16C32.5 24.8224 25.3224 32 16.5 32ZM16.5 1.34564C8.41975 1.34564 1.84435 7.91975 1.84435 16.0013C1.84435 24.0828 8.41847 30.6569 16.5 30.6569C24.5815 30.6569 31.1556 24.0828 31.1556 16.0013C31.1556 7.91975 24.5815 1.34564 16.5 1.34564Z" fill="#FF3E57"/>
                        <path d="M23.8814 25C23.4666 25 23.053 24.8415 22.736 24.5258L8.97446 10.764C8.34185 10.1314 8.34185 9.10709 8.97446 8.47447C9.60707 7.84184 10.6314 7.84184 11.264 8.47447L25.0255 22.2363C25.6582 22.8689 25.6582 23.8932 25.0255 24.5258C24.7099 24.8415 24.295 25 23.8801 25H23.8814Z" fill="white"/>
                        </svg>
                    </figure>
                    <span class="label-static">Nein</span>
                </div>
            </div>
        </div>

        <div class="rwe-info-wrapper" v-else>
            <v-button
                label="Weiter"
                size="lg"
                type="submit"
                @onClick="onClickButton()"
                position="center"
            ></v-button>

            <div class="text-info-wrapper">
                <strong class="new-text-xl">Welche Vorteile haben Sie von der Teilnahme an der Studie?</strong>
                <ul class="new-text-lg text-color-default">
                    <li>Sie können zu einer <strong>Verbesserung der Behandlung</strong> von Menschen mit Typ-2-Diabetes beitragen</li>
                    <li><strong>Minimaler Aufwand</strong> von nur 15 Minuten pro Fragebogen (insgesamt fünf Stück)</li>
                    <li ><strong>160 €</strong> für Sie:</li>
                </ul>
                <p class="new-text-lg text-color-default"><strong>30 €</strong> nach dem zweiten Fragebogen nach 3 Monaten, weitere <strong>30 €</strong> nach dem dritten Fragebogen nach 6 Monaten und <strong>100 €</strong> nach dem fünften Fragebogen nach 12 Monaten!</p>
                <p class="new-text-lg text-color-default">Sie entscheiden, ob Sie das Geld auf Ihr Konto überwiesen bekommen wollen oder ob Sie es an die Deutsche Diabetes-Hilfe* spenden möchten!</p>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    props: {
        uuid: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        }
    },

    methods: {
        onClickButton () {
            this.submit()
        },
        openModal() {
            $("#modal-quiz").modal();
        },
        submit() {
            var data = {
                uuid: this.uuid,
                answers: {
                    question_1: {
                        key: 'agreement',
                        value: 'yes'
                    },
                    last_tab: {
                        key: 'last_tab',
                        value: '1'
                    }
                }
            }

            axios
                .post('/rwe-study', data, {
                    headers: {
                        'Accept-Language': 'de'
                    }
                })
                .then((e) => {
                    this.$emit('clicked', data.answers, true)
                })
                .catch((e) => {
                    console.log(e.response)
                    Vuemit.fire('Button--sending-failed', true)
                })
        }
    }
}
</script>
